import { useState } from "react";
import { Plus, Clapperboard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useScenes } from "@/components/studio/SceneLibrary";

export const AddCardButtons = ({ uid, onAddChapter, onPlaceScene, onNewScene }) => {
  const [open, setOpen] = useState(false);
  const { data: scenes = [] } = useScenes(uid);
  return (
    <div className="flex gap-2">
      <Button onClick={onAddChapter} data-testid="add-chapter-button"><Plus className="mr-1 h-4 w-4" />New chapter</Button>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild><Button variant="outline" data-testid="place-scene-button"><Clapperboard className="mr-1 h-4 w-4" />Place scene</Button></PopoverTrigger>
        <PopoverContent align="end" className="w-72 p-2" data-testid="place-scene-popover">
          <div className="max-h-64 overflow-y-auto lf-scroll">
            {scenes.length === 0 && <p className="p-2 text-xs text-[#A8A090]">No scene notes yet.</p>}
            {scenes.map((s) => (
              <button key={s.id} onClick={() => { setOpen(false); onPlaceScene(s); }} className="block w-full truncate rounded px-2 py-1.5 text-left text-sm text-[#F3EBDD] hover:bg-[#1A202C]" data-testid={`place-scene-${s.id}`}>{s.title}</button>
            ))}
          </div>
          <Button size="sm" variant="ghost" className="mt-1 w-full justify-start" onClick={() => { setOpen(false); onNewScene(); }} data-testid="place-new-scene"><Plus className="mr-1 h-3.5 w-3.5" />New scene note…</Button>
        </PopoverContent>
      </Popover>
    </div>
  );
};
